import { Icon } from '@nazka/nazka.mapframe.components';
import { faChevronUp, faChevronDown } from '@fortawesome/pro-solid-svg-icons';

import './sort-icon.styl';

function SortIcon({ sortDirection }) {
  return (
    <div className="sort-icon">
      <Icon
        icon={faChevronUp}
        size="9px"
        css={{
          opacity: (!sortDirection || sortDirection === 'asc') ? 1 : 0,
        }}
      />
      <Icon
        icon={faChevronDown}
        size="9px"
        css={{
          opacity: (!sortDirection || sortDirection === 'desc') ? 1 : 0,
        }}
      />
    </div>
  );
}

export default SortIcon;